import Form from "./StudentProgressForm";
import Input from "./StudentProgressInput";

export default {
  Form,
  Input,
};
